async function request(url, options = {}) {
  const response = await fetch(url, {
    credentials: "same-origin",
    ...options,
    headers: {
      ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...options.headers,
    },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `请求失败（${response.status}）`);
  }
  return response.status === 204 ? null : response.json();
}

export const api = {
  config: () => request("/api/config"),
  unlock: (key) => request("/api/auth", { method: "POST", body: JSON.stringify({ key }) }),
  photos: () => request("/api/photos"),
  updatePhoto: (id, changes) => request(`/api/photos/${id}`, { method: "PATCH", body: JSON.stringify(changes) }),
  deletePhoto: (id) => request(`/api/photos/${id}`, { method: "DELETE" }),
};

export function uploadPhotos({ files, location, styles, onProgress }) {
  return new Promise((resolve, reject) => {
    const form = new FormData();
    files.forEach((file) => form.append("photos", file));
    form.append("location", location || "");
    form.append("styles", JSON.stringify(styles));

    const xhr = new XMLHttpRequest();
    xhr.open("POST", "/api/photos");
    xhr.withCredentials = true;
    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable) onProgress?.(Math.round((event.loaded / event.total) * 100));
    });
    xhr.addEventListener("load", () => {
      let body = {};
      try { body = JSON.parse(xhr.responseText); } catch { /* ignore non-json errors */ }
      if (xhr.status >= 200 && xhr.status < 300) resolve(body);
      else reject(new Error(body.error || `上传失败（${xhr.status}）`));
    });
    xhr.addEventListener("error", () => reject(new Error("网络中断，照片仍保留在手机中")));
    xhr.send(form);
  });
}
